import React from "react";
import classnames from "classnames";
import { Button } from "cxa-components";
import {
  RemoveCircleIcon,
  FileUnknownIcon,
  FileImageIcon,
  FilePdfIcon,
} from "cxa-icons";
import PDFViewer from "../../../../components/claim/PDFViewer";

const getFileType = type => {
  if (type.includes("image")) return "img";
  else if (type.includes("pdf")) return "pdf";
  return type;
};

const fileIconMapping = {
  img: FileImageIcon,
  pdf: FilePdfIcon,
};

const File = ({
  className,
  file,
  onDelete,
  name,
  type,
  src,
  size,
  disabled,
  ...rest
}) => {
  const prefixCls = "file";
  const fileType = getFileType(type);
  const FileIcon = fileIconMapping[fileType] || FileUnknownIcon;

  const previewCls = `${prefixCls}__preview`;
  const iconCls = `${prefixCls}__icon`;
  const nameCls = `${prefixCls}__name`;
  const detailsCls = `${prefixCls}__details`;
  const deleteBtnCls = `${prefixCls}__delete-btn`;

  const componentCls = classnames(
    prefixCls,
    {
      [`${prefixCls}--${fileType}`]: fileType,
    },
    className
  );

  const Preview = (
    <a
      href={src}
      target="_blank"
      rel="noopener noreferrer"
      className={previewCls}
    >
      {fileType === "img" ? <img src={src} alt="file-preview"/> : <PDFViewer pdfUrl={src} size="small" />}
    </a>
  );

  return (
    <figure className={componentCls}>
      {Preview}
      <figcaption className={detailsCls}>
        <FileIcon className={iconCls} />
        <div className={nameCls}>{name}</div>
      </figcaption>
      {onDelete ? (
        <Button
          type="button"
          onClick={onDelete}
          icon
          aria-label="Remove"
          className={deleteBtnCls}
          disabled={disabled || false}
        >
          <RemoveCircleIcon />
        </Button>
      ) : null}
    </figure>
  );
};

export default File;



// WEBPACK FOOTER //
// ./casper/sass/components/file/file.js